import createReducer from '../lib/createReducer';
import * as types from '../actions/types';

const initialState = {
  isFetching: false,
  data: {},
  downloadDetails: {},
  isLoggedIn: false,
};

export const downloadReducer = createReducer(initialState, {
  [types.DOWNLOAD_RESPONSE](state, action) {
    return {
      ...state,
      data: action.response.data,
      errorMessage: action.response.message,
    };
  },
  [types.DOWNLOAD_DETAIL_RESPONSE](state, action) {
    return {
      ...state,
      downloadDetails: action.response.data,
      errorMessage: action.response.message,
    };
  },
  [types.LOG_OUT]() {
    return {
      ...initialState,
    };
  },
});
